// store/openApiThunks.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/api/api";

export const fetchTasks = createAsyncThunk(
  "tasksApis/fetchTasks",
  async () => {
    const response = await api.get("/tasks/assigned");
    return response.data.data;
  }
);

export const fetchCreatedTasks = createAsyncThunk(
  "tasksApis/fetchCreatedTasks",
  async ({ page = 1, page_size = 10, status = null } = {}) => {
    let url = `/tasks/created/all?page=${page}&page_size=${page_size}`;
    if (status) {
      url += `&status=${status}`;
    }
    const response = await api.get(url);
    return response.data.data;
  }
);

export const createTask = createAsyncThunk(
  "tasksApis/tasksCreate",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await api.post("/tasks/create", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.data;
    } catch (error) {
      
      return rejectWithValue( error);
    }
  }
);

export const taskUsers = createAsyncThunk(
  "tasksApis/taskUsers",
  async () => {
    const response = await api.get("/tasks/users");
    return response.data.data;
  }
);

export const taskGroups = createAsyncThunk(
  "tasksApis/taskGroups",
  async () => {
    const response = await api.get("/tasks/groups");
    return response.data.data;
  }
);

export const tasksApprove = createAsyncThunk(
  "tasksApis/tasksApprove",
  async () => {
    const response = await api.get("/tasks/to-approve");
    return response.data.data;
  }
);

export const myTasks = createAsyncThunk(
  "tasksApis/myTasks",
  async () => {
    const response = await api.get("/tasks/created");
    return response.data.data;
  }
);

export const taskDetail = createAsyncThunk(
  "tasksApis/taskDetail",
  async (id) => {
    const response = await api.get(`/tasks/task/${id}`);
    return response.data.data;
  }
);

export const deleteTask = createAsyncThunk(
  "tasksApis/deleteTask",
  async (id) => {
    const response = await api.delete(`/tasks/delete/${id}`);
    return response.data.data;
  }
);

export const addTaskStep = createAsyncThunk(
  "tasksApis/addTaskStep",
  async ({ taskId, title }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/tasks/${taskId}/steps`, { title });
      return { taskId, step: response.data.data };
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const completeTaskStep = createAsyncThunk(
  "tasksApis/completeTaskStep",
  async ({ taskId, stepId }, { rejectWithValue }) => {
    
    try {
      const response = await api.patch(`/tasks/${taskId}/steps/${stepId}/complete`);
      return response.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const deleteTaskStep = createAsyncThunk(
  "tasksApis/deleteTaskStep",
  async ({ taskId, stepId }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/tasks/${taskId}/steps/${stepId}`);
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message);
      }
      return rejectWithValue(error.message);
    }
  }
);

export const startTask = createAsyncThunk(
  "tasksApis/StartTask",
  async (taskId) => {
    const response = await api.post(`/tasks/start/${taskId}`);
    return response.data.data;
  }
);

export const submitTask = createAsyncThunk(
  "tasksApis/SubmitTask",
  async ({ taskId, formData }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/tasks/submit/${taskId}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.data;
    } catch (err) {
      
      if (err.response && err.response.data) {
        return rejectWithValue(err.response.data.message);
      }
      return rejectWithValue(err.message);
    }
  }
);


export const submitTaskWithFile = createAsyncThunk(
  "tasksApis/SubmitTaskWithFile",
  async ({ taskId, formData }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/tasks/${taskId}/attachments/submit`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const approveTask = createAsyncThunk(
  "tasksApis/ApproveTask",
  async (taskId, { rejectWithValue }) => {
    try {
      const response = await api.post(`/tasks/${taskId}/approve`);
      return response.data.data;
    }
    catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// reject task with reason and deadline
export const rejectTask = createAsyncThunk(
  "tasksApis/RejectTask",
  async ({ taskId, reason, deadline }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("reason", reason);
      if (deadline) {
        formData.append("deadline", deadline);
      }

      const response = await api.post(`/tasks/${taskId}/reject`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);


export const editMyTask = createAsyncThunk(
  "tasksApis/editMyTask",
  async ({ taskId, data }, { rejectWithValue }) => {
    try {
      const isFD = typeof FormData !== "undefined" && data instanceof FormData;

      if (isFD) {
        const dbg = {};
        for (const [k, v] of data.entries()) dbg[k] = v instanceof File ? `[File:${v.name}]` : v;
      } else {
      }


      const res = await api.put(`/tasks/update/${taskId}`, data, {
        withCredentials: true, 
        headers: isFD
          ? { "Content-Type": "multipart/form-data" }
          : { "Content-Type": "application/json" },
      });


      return res.data.data;
    } catch (error) {
      if (error?.response?.data) {
        return rejectWithValue(error.response.data.message || "Server xatosi");
      }
      return rejectWithValue(error?.message || "Tarmoq xatosi");
    }
  }
);


export const deleteMyTask = createAsyncThunk(
  "tasksApis/deleteMyTask",
  async ({ taskId, data }, { rejectWithValue }) => {
    try {
      const response = await api.delete(`/tasks/delete/${taskId}`, data);
      return response.data.data;
    } catch (error) {
      if (error.response && error.response.data) {
        return rejectWithValue(error.response.data.message || "Server xatosi");
      }
      return rejectWithValue(error.message || "Tarmoq xatosi");
    }
  }
);